import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/models/validationmethod';
import { CommonService } from 'src/app/shared/services/common.service';
import { JsignalService } from 'src/app/shared/services/jsignal.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ManageVisualsService } from 'src/app/shared/services/manage-visuals.service';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { ReportlinksserviceService } from '../../reportlinks/reportlinksservice.service';
import { TemplateReportService } from 'src/app/shared/services/template-report.service';

export interface EditData {
  editData: any;
}
@Component({
    selector: 'app-review-activity-popup-config',
    templateUrl: './review-activity-popup-config.component.html',
    styleUrls: ['./review-activity-popup-config.component.scss'],
    standalone: false
})
export class ReviewActivityPopupConfigComponent implements OnInit {

  validations_form: UntypedFormGroup;
  validation_messages;
  activityType;
  activityName;
  activityTypeList:any=[]
  updateData
  visualData: any;
  datasets: any[];
  selectedDataset: any = null;
  getdata: any;
  UserRolesWithRoleId: any;
  AllReportTemplates: any;
selectedVisual: any;
selectedTemplate: any;
  dataSetId: any;
titleText:string="Create Review Activity Configuration"
  editVisualId: any;
  editTemplateId: any;
  buttonName:string="Create"



  constructor( private msg: ErrorMessages,
    public dialogref: MatDialogRef<ReviewActivityPopupConfigComponent>,
    private commonService:CommonService,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private jsignalsService: JsignalService,
    private validation: validationmethod,
    @Inject(MAT_DIALOG_DATA) public data: EditData,
    private localStorage: LocalStorageSettingsService,
    private visualServices:ManageVisualsService,
    private linkservice: ReportlinksserviceService,
    private service: ReportingServiceService,
    private Reportservice: TemplateReportService,
    
  ) {
    this.validation_messages = this.msg.reviewActivityConfig;
   }

  ngOnInit(): void {
     this.spinner.start();
     this.formValidation()
    this.fetchlookupvalue()
    this.setupConditionalValidation();

     this.updateData = this.data?.editData;

     //Edit 
     if(this.updateData != undefined){
      console.log(this.updateData);
      this.titleText="Update Review Activity Configuration"
      this.activityName=this.updateData?.activityName
      this.activityType=this.updateData?.activityType
        this.dataSetId = this.updateData?.datasetId;
        this.editVisualId = this.updateData?.visualId;
        this.editTemplateId = this.updateData?.reportTemplateId;
        // this.getVisuals();
        this.buttonName="Update"
     }

    this.Useroles(); // first load user roles
    this.loadAllDatasets(); // then load datasets
    this.fetchReportTemplates();
   
  }
formValidation() {
    this.validations_form = new UntypedFormGroup({
      activityType: new UntypedFormControl('', [Validators.required]),
      activityName: new UntypedFormControl('', [Validators.required,this.validation.restrictAllSpecialCharactersExceptHyphenAndUnderscore]),
      dataset: new UntypedFormControl(''),
      reportTemplate: new UntypedFormControl(''),
      visual: new UntypedFormControl(''),

    });
  }
  
  fetchlookupvalue() {
    // this.spinner.start();
    this.commonService.getlookupVauleByLookUpType('Activity Types').subscribe({
        next: (result: any) => {
         this.activityTypeList = result;
         console.log(this.activityTypeList);
        //  this.spinner.stop();
        },
        error: (err) => {
          console.error(`Error loading lookup Activity Types":`, err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          //         // this.loadGridData();
          // this.spinner.stop();
        },
      });
  }
  onCancel(){
    this.dialogref.close();
  }
  onCreate(){
     this.validations_form.markAllAsTouched();

     
      if (this.validations_form.invalid) {
      // displaying validation messages
      this.validation.validateAllFormFields(this.validations_form);

      this.validation.getvalidationmessage();
        return;
      }
    
    
        const dataset = this.validations_form.get('dataset')?.value;
        const report = this.validations_form.get('reportTemplate')?.value;

  if (!dataset && !report) {
    this.snackBar.open("Select either Dataset or Report Template", "OK", {
      duration: 3000
    });
    return;
  }
    
    const DnsName = this.localStorage.getSettings("dnsName");
    const Workspaceid = this.localStorage.getSettings("WorkspaceId");   
    const activityDetails=[{
      activityType:this.activityType,
      activityName:this.activityName,
      dataSetId:this.dataSetId,
      visualId:this.selectedVisual?.visualId,
      reportTemplateId:this.selectedTemplate?.reportTemplateId,
      dnsid:DnsName,
      workspaceid:Workspaceid
    }];
    console.log(activityDetails);


    // In edit close the dialog send single object to parent 
    if(this.updateData != undefined){
      const activityDetailsUpdate = {
      activityType: this.activityType,
      activityName: this.activityName,
      dataSetId: this.dataSetId,
      visualId: this.selectedVisual?.visualId,
      reportTemplateId: this.selectedTemplate?.reportTemplateId,
      dnsid:DnsName,
      workspaceid:Workspaceid
 };
      this.dialogref.close(activityDetailsUpdate);
    }
    // Create mode multiple objects can be created so sending array to parent and closing the dialog
    else{
      this.spinner.start();
      this.jsignalsService.insertReviewActivityConfigDetails(activityDetails).subscribe(response=>{
        if (response.error == true) {
          this.spinner.stop();
          this.snackBar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
        } else {
          this.spinner.stop();
          this.snackBar.open(response.statusMessage, "OK", {
              duration: 5000,
            });
         
        }
         this.dialogref.close(activityDetails);
      })
    }
 

    }

      getVisuals() {
        this.spinner.start();

        this.visualServices
          .retreiveManageVisualsDataOnDatasetId(this.dataSetId)
          .subscribe(
            (response) => {
              if (response?.error === true) {
                this.snackBar.open(response.statusMessage, "OK", {
                  duration: 5000,
                });
                this.spinner.stop();
                return;
              }

              let visualList: any = response;

              this.visualData = visualList.filter(
                (visual) => visual.status === "Yes"
              );

              if (this.editVisualId) {
                this.selectedVisual = this.visualData.find(
                  (v) => v.visualId == this.editVisualId
                );
              }

              if (this.visualData.length === 0) {
                console.error("No visuals available after filtering");
              }

              this.spinner.stop();
            },
            (error) => {
              console.error("API error:", error);
              this.spinner.stop();
            }
          );
      }

        loadAllDatasets() {
    // this.spinner.start();      
    this.linkservice
      .retrievereport(
        this.localStorage.getSettings("UserId"),
        this.localStorage.getSettings("dnsName"),
        this.localStorage.getSettings("AuthUsername")
      )
      .subscribe((response) => {
        
        console.log(response);
        // checking if response is true or not
        if (response.error == true) {
          this.snackBar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
          // this.rowbindingdata.setGridOption('rowData', []);
          this.datasets = [];
          this.selectedDataset = null;
          // this.spinner.stop();
        } else {
          // below code added for dispaly associated roles of Dataset in the Grid
          console.log(response);
          this.getdata = response;
          console.log(this.getdata);
          for (let i = 0; i < this.getdata.length; i++) {
            let stringValues = "";
            if (this.getdata[i].dataset_rolesIds) {
              let subString = this.getdata[i].dataset_rolesIds.split(",");
              console.log(subString);
              for (let j = 0; j < subString.length; j++) {
                console.log(this.UserRolesWithRoleId);
                for (let k = 0; k < this.UserRolesWithRoleId.length; k++) {
                  console.log(this.UserRolesWithRoleId[k][0]);
                  if (this.UserRolesWithRoleId[k][0] == subString[j]) {
                    if (stringValues.length == 0) {
                      stringValues = this.UserRolesWithRoleId[k][1];
                      break;
                    } else {
                      stringValues =
                        stringValues + "," + this.UserRolesWithRoleId[k][1];
                      break;
                    }
                  }
                }
              }
              this.getdata[i]["dataset_rolesIdStrings"] = stringValues;
            }
          }
          console.log(this.getdata);
          // Filter active datasets only (status === 'Yes') && Completed Data Set
          this.datasets = this.getdata.filter(
            (ds: any) =>
              ds.status === "Yes" && ds.generationStatus === "Completed"
          );

          //Edit Scenairo - Set selected dataset based on datasetId and load visuals for that dataset
          if (this.dataSetId) {
            this.selectedDataset = this.datasets.find(
              (ds) => ds.reportcreationid == this.dataSetId
            );

            if (this.selectedDataset) {
              this.dataSetId = this.selectedDataset.reportcreationid;

              this.getVisuals(); // load visuals after dataset set
            }
          }
        }
        this.spinner.stop();
      });
  }
  onDatasetChange() {

    if (this.selectedDataset) {
      console.log("Selected Dataset:", this.selectedDataset);

      console.log("Dataset Name:", this.selectedDataset.datasetname,
        "| DatasetId:",
        this.selectedDataset.reportcreationid,
        "| Type:",
        this.selectedDataset.datasetType,
        "| Status:",
        this.selectedDataset.status
      );

      this.dataSetId=this.selectedDataset.reportcreationid;
      console.log("Selected Dataset ID:", this.dataSetId);
    this.visualData = [];
    this.selectedVisual = null;
      this.getVisuals();
    } else {
      console.log("No dataset selected");
    }
  }
  Useroles(): void {
    // this.spinner.start();
    const dnsid = this.localStorage.getSettings("dnsName");
    if (dnsid) {
      this.service.getUserRoles(dnsid).subscribe(
        (response) => {
          this.UserRolesWithRoleId = response; // Assign fetched user roles to the types array
          console.log(this.UserRolesWithRoleId);
          // this.spinner.stop();
        },
        (error) => {
          console.error("Error fetching user roles:", error);
          this.snackBar.open("Error fetching user roles", "OK", {
            duration: 5000,
          });
          // this.spinner.stop();

        }
      );
    }
  }

  // Fetch All Report Templates based on dnsid

  fetchReportTemplates() {
    this.Reportservice.retrieveReportTemplatesByDnsId().subscribe(
      (response) => {
        console.log(response);

        if (response.error == true) {
          // this.spinner.stop();

          this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });
        } else {
          // this.spinner.stop();
          this.AllReportTemplates = (response as any).filter(
            (t: any) => t.status === "Yes"
          );
          console.log(this.AllReportTemplates);

          if (this.editTemplateId) {
          this.selectedTemplate = this.AllReportTemplates.find(
            (t) => t.reportTemplateId == this.editTemplateId
          );
        }
        }
      }
    );
  }

  //
  onReportSelected() {
    if (this.selectedTemplate) {
      console.log(this.selectedTemplate);
      console.log("Report Id :", this.selectedTemplate.reportTemplateId);
      console.log("Report Type :", this.selectedTemplate.reportTypeName);
    } else {
      console.error("No Report Selected");
    }
  }

  clearState(){
    this.selectedDataset = null;
    this.visualData = [];
    this.selectedVisual = null;
    this.selectedTemplate = null;
    this.activityName = null;
    this.activityType = null;
    this.editTemplateId = null;
    this.editVisualId = null;
    this.dataSetId = null;
  }

  setupConditionalValidation() {
  const datasetCtrl = this.validations_form.get('dataset');
  const reportCtrl = this.validations_form.get('reportTemplate');
  const visualCtrl = this.validations_form.get('visual');

  // When dataset changes
  datasetCtrl.valueChanges.subscribe(value => {
    if (value) {
      // Dataset selected → Visual required
      visualCtrl.setValidators([Validators.required]);

      // Either-or rule → remove report required
      reportCtrl.clearValidators();
    } else {
      visualCtrl.clearValidators();
    }

    visualCtrl.updateValueAndValidity();
    reportCtrl.updateValueAndValidity();
  });

  // When report template changes
  reportCtrl.valueChanges.subscribe(value => {
    if (value) {
      // Report selected → dataset not required
      datasetCtrl.clearValidators();
      visualCtrl.clearValidators();
    }

    datasetCtrl.updateValueAndValidity();
    visualCtrl.updateValueAndValidity();
  });
}

    
}
